export default __webpack_public_path__ + "static/media/dtt-tool.985edc9a.png";